import React from 'react';
import {Typography} from "@material-ui/core";
import ClearIcon from '@material-ui/icons/Clear';
import CheckIcon from '@material-ui/icons/Check';
import removeParenthesis from "../../utils/removeParenthesis";
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {base16AteliersulphurpoolLight} from 'react-syntax-highlighter/dist/esm/styles/prism';
import _ from 'lodash';

/**
 * @param description
 * @param attributeType
 * @returns {JSX.Element}
 * @constructor
 */
const AttributeTypeCard = ({ description, attributeType }) => {

    /**
     * @param content
     * @param idx
     * @returns {JSX.Element}
     * @constructor
     */
    const DisplayContent = ({content, idx, type}) => {
        if (type === 'JSON') {
            return (
                <SyntaxHighlighter language="json" style={base16AteliersulphurpoolLight}>
                    {JSON.stringify(content, null, 1)}
                </SyntaxHighlighter>
            )
        }
        return (
            <Typography
                key={idx}
                variant="body2"
                paragraph
                style={{ marginBottom: '5px'}}
            >
                <>
                    {_.has(content, 'value') ? content.value : content}
                </>
            </Typography>
        );
    };

    const renderAttribute = (description, attributeType) => {
        let newContent = '';
        let type = 'map';
        switch (attributeType) {
            case 'BANK_ACCOUNT_DIGITS':
            case 'BANK_LENGTH_MONTHS':
            case 'EMPLOYER_LENGTH':
            case 'MONTHLY_INCOME':
                newContent = removeParenthesis(description[0].value).split(',');
                break;
            case 'LOAN_AMOUNT':
                newContent = removeParenthesis(description[0].value.replace('LoanAmountRange', '')).split(',');
                break;
            case 'ZIP_CODE':
            case 'HOME_STATE':
                newContent = removeParenthesis(description[0].value).split(',');
                break;
            case 'MILITARY':
            case 'BANK_ACCOUNT_AND_ROUTING':
                type = 'component';
                if (description[0].value === 'false') {
                    newContent = <ClearIcon />;
                }

                newContent = <CheckIcon />;
                break;
            case 'RECENCY_STATIC':
            case 'RECENCY_DYNAMIC':
                type = 'JSON';
                let newArr = [];
                description.forEach(content => {
                    let newContent = Array.isArray(content) ? content[0].value : content.value;
                    let updatedContent = removeParenthesis(newContent).split(',');
                    newArr.push(updatedContent);
                });
                newContent = [];
                newArr.forEach(content => {
                    let newObj = {};
                    content.forEach(item => {
                        let keyVal = Array.from(new URLSearchParams(item).entries()).reduce((a, [k, v]) => ((a[k.trim()] = v.trim(), a)), {});
                        const key = Object.keys(keyVal);
                        if (key[0] === 'constraint') {
                            const value = keyVal[key[0]].split('=');
                            const newValue = value[1];
                            keyVal = {
                                "constraint": newValue
                            };
                        }

                        if (key[0] === 'variants') {
                            const variantMap = new Map();
                            let value = keyVal[key[0]].split('|');
                            value.forEach(variant => {
                                const variantKeyVal = variant.split(':');
                                variantMap.set(variantKeyVal[0], variantKeyVal[1]);
                            });

                            const variants = Object.fromEntries(variantMap);
                            keyVal = {
                                "variants": variants
                            }
                        }

                        newObj = Object.assign(newObj, keyVal);
                    });
                    newContent.push(newObj);
                });
                break;
            case 'Configs':
                type = 'JSON';
                newContent = description.map(item => {
                    delete item['__typename'];
                    return item;
                });
                break;
            default:
                newContent = description;
                break;
        }
        if (type === 'component' || type === 'default') {
            return <DisplayContent content={newContent} type={type} />
        }

        if (!newContent.length) {
            return null;
        }

        return (
            <>
                {newContent.map((content, idx) => {
                    return (
                        <DisplayContent key={idx.toString()} content={content} idx={idx.toString()} type={type}/>
                    );
                })}
            </>
        );
    };

    return (
        <>
            {renderAttribute(description, attributeType)}
        </>
    );
};

export default AttributeTypeCard;
